// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { MenuItem, TextField } from '@mui/material';

export default function RHFSelectBox({ option, name, ...other }: any) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error?.message}
          {...other}
        >
          <MenuItem value="">選択してください</MenuItem>

          {option.map((obj: any, i: any) => (
            <MenuItem key={i} value={obj}>
              {obj}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}
